import { useState } from 'react';
import { IComponentCss } from '@tap/mui-ui';
import { DropdownMenu } from '@tap/mui-ui';
import { Grid, Button, ButtonGroup } from '@mui/material';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import { IApiIssue } from '@tap/data-providers';
import { useDocuemtnSchema, useDocument, useTimeTracking } from '@tap/doc-ui';

/*
*   Кнопки действий
*/

type IIssuePageToolbarProps = {
    issue: IApiIssue,
    handleAction: (toolbarAction: ToolbarAction, payload?: any) => void,
}

export enum ToolbarAction {
    EditIssue,
    AddComment,
    AssignUser,
    ClickWorkflowBtn,
    DeleteIssue,
    CloneIssue,
    CreateRelationLink,
    AttachFile,
    TrackTime,
}

const css: IComponentCss = {
    wrap: {
        mt: 3,
        mb: 3,
        paddingBottom: '16px',
        borderBottom: '1px solid #E0E0E0',
    },
    actionButton: {
        marginRight: 2,
    },
    closeButton: {
        marginLeft: '40px',
    },
}

export default function IssuePageToolbar({
    issue,
    handleAction,
}: IIssuePageToolbarProps) {

    const documentCode = issue.issueKey.split('-')[0];
    const documentSchema = useDocuemtnSchema(documentCode);
    const { document } = useDocument();

    const { openAddTimeTrackingDialog } = useTimeTracking();


    const workflowActions = documentSchema.settings.workflow.filter(wf => wf.fromStatus === issue.statusCode);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleOpenMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    return (
        <Grid container sx={css.wrap}>
            <ButtonGroup variant='outlined' >
                <Button
                    variant='action'
                    sx={css.actionButton}
                    startIcon={<CreateOutlinedIcon />}
                    onClick={() => handleAction(ToolbarAction.EditIssue, { document })}
                >
                    Изменить
                </Button>
                <Button
                    variant='action'
                    sx={css.actionButton}
                    startIcon={<CommentOutlinedIcon />}
                    onClick={() => handleAction(ToolbarAction.AddComment, { document })}
                >
                    Комментарий
                </Button>
                <Button
                    variant='action'
                    sx={css.actionButton}
                    onClick={() => handleAction(ToolbarAction.AssignUser, { document })}
                >
                    Назначить
                </Button>
                <Button
                    variant='action'
                    onClick={handleOpenMenuClick}
                    endIcon={<ExpandMoreOutlinedIcon />}
                >
                    Другое
                </Button>
            </ButtonGroup>

            <ButtonGroup>
                {workflowActions.map((wfa, index) => (
                    <Button
                        key={index}
                        variant='action'
                        sx={{ ...css.actionButton, ...css.closeButton }}
                        onClick={() => handleAction(ToolbarAction.ClickWorkflowBtn, { document, wfa })}
                    >
                        {wfa.toolbarAction.button}
                    </Button>

                ))}


            </ButtonGroup>

            <DropdownMenu
                id='profile-menu'
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
                menuItems={[
                    {
                        onClick: () => {
                            openAddTimeTrackingDialog();
                            handleAction(ToolbarAction.TrackTime);
                        }, label: 'Вести журнал работ',
                    },
                    { onClick: () => handleAction(ToolbarAction.CreateRelationLink), label: 'Связать' },
                    { onClick: () => handleAction(ToolbarAction.AttachFile), label: 'Прикрепить файлы' },
                    { onClick: () => handleAction(ToolbarAction.CloneIssue), label: 'Клонировать' },
                    { onClick: () => handleAction(ToolbarAction.DeleteIssue), label: 'Удалить' },
                ]}
            />

        </Grid>
    );
}
